import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-sub-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/disciplinary-sub-types', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/disciplinary-sub-types/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/disciplinary-sub-types/${data.dis_sub_type_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/disciplinary-sub-types/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const disciplinaryType = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-sub-types/disciplinary-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const attStatus = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-sub-types/attendance-status', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  disciplinaryType,
  attStatus
}
